import { Injectable } from '@angular/core';
import { IRedirect } from 'src/app/shared/interfaces/redirect';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RedirectValidatorService {
  constructor() {}

  public getValidRedirectParam(): IRedirect | null {
    const queryParams = new URLSearchParams(window.location.search);
    const redirectParam = decodeURIComponent(queryParams.get('redirect'));

    if (!this.validateRedirectUrl(redirectParam)) return null;

    const splittedRedirectParam = redirectParam.split('?');
    const route = splittedRedirectParam[0].replace(environment.urlPvet, '');
    const query = new URLSearchParams('?' + splittedRedirectParam[1]);

    const videosNadEventsQuery: { video?: string; event?: string } = {};
    const eventParam = query.get('event');
    if (eventParam) videosNadEventsQuery.event = eventParam;
    const videoParam = query.get('video');
    if (videoParam) videosNadEventsQuery.video = videoParam;

    return {
      fullEncoded: encodeURIComponent(redirectParam),
      route,
      query: videosNadEventsQuery
    };
  }

  private validateRedirectUrl(url: string): boolean {
    const validUrls = [
      `${environment.urlPvet}conteudos/informativos-tecnicos/informativos-tecnicos-read/`,
      `${environment.urlPvet}conteudos/materiais-de-apoio/materiais-de-apoio-read/`,
      `${environment.urlPvet}conteudos/videos-e-eventos?video=`,
      `${environment.urlPvet}conteudos/videos-e-eventos?event=`
    ];
    return validUrls.some((validUrl) => url?.includes(validUrl));
  }
}
